<template>
  <transition name="slide-up">
    <div
      v-if="isOpen"
      class="drawer-overlay"
      @click="closeDrawer"
    >
      <div
        class="drawer-content"
        :class="{ 'with-navbar': useNavBar }"
        @click.stop
      >
        <div class="drawer-header">
          <slot name="header"></slot>
        </div>
        <div class="drawer-body">
          <slot></slot>
        </div>
        <div class="drawer-footer">
          <slot name="footer"></slot>
        </div>
        <button
          class="close-button"
          @click="closeDrawer"
        >
          <svg class="icon-cancel">
            <use :xlink:href="`#${cancel}`" />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import cancel from '@/assets/icons/cancel.svg'

  export default defineComponent({
    name: 'BottomDrawer',
    props: {
      isOpen: {
        type: Boolean,
        required: true,
      },
      useNavBar: {
        type: Boolean,
        default: false,
      },
      closeButtonText: {
        type: String,
        default: 'Lukk'
      }
    },
    emits: ['close'],
    setup(props, { emit }) {
      const closeDrawer = () => {
        emit('close')
      }

      return {
        closeDrawer,
        cancel,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .drawer-overlay {
    position: fixed;
    bottom: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 1000;
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    position: relative;
    max-width: $breakpoint-sm;
    height: 100%;
    background: white;
  }

  .drawer-header {
    display: flex;
    justify-content: center;
    padding-right: 32px;
    padding-left: 16px;
    font-weight: 600;
    box-shadow: $box-shadow-card;
  }

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 2;
  }

  .icon-cancel {
    width: 16px;
    height: 16px;
  }

  .drawer-body {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    /* max-height: calc(90vh - 4rem); */
    /* margin: 0 -1rem; */
    max-height: 100%;
    padding-right: 16px;
    /* padding-bottom: 16px; */
    padding-left: 16px;

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .drawer-footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding: 16px;
  }

  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: transform 0.3s ease;
  }

  .slide-up-enter {
    transform: translateY(100%);
  }

  .slide-up-leave-to {
    transform: translateY(100%);
  }
</style>
